import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    {
      value: 1,
      label: 'S1',
      description: 'Supply of goods and services (10% GST)',
    },
    {
      value: 2,
      label: 'S2',
      description: 'Supply of GST-free goods and services',
    },
    { value: 3, label: 'S3', description: 'Input taxed supplies (no GST)' },
    { value: 4, label: 'S4', description: 'Exported goods and services' },
    { value: 5, label: 'S5', description: 'Out-of-scope transactions' },
    { value: 6, label: 'S6', description: 'Wine equalisation tax' },
    { value: 7, label: 'S7', description: 'Deductible Gift Receipient (DGR)' },
  ],
});
